import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.ProfileSettingWelcomeBackCollectProfile,
  {
    key: LocationVarKey.ProfileSettingWelcomeBackMessage,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeBackCollectionMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeBackContactMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeBackWantShortProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeBackWantSecondaryOptional,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackWantShortProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeBackWantConfirmProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeBackWantCollectPersona,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader
        {...page}
        subheading="For returning users, require customers to provide their contact information before they can chat with the bot or a human."
      >
        {" "}
        Welcome Back
      </PageHeader>

      <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeBackCollectProfile} label="Collect Profile" />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackCollectProfile, "1")}>
        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ProfileSettingWelcomeBackMessage} />
        <DropdownRow
          {...page}
          marginTop
          label=" Collection Method"
          keyName={LocationVarKey.ProfileSettingWelcomeBackCollectionMethod}
          options={[
            {
              label: "Conversational",
              value: "Conversational"
            },
            {
              label: "Info Collect Card",
              value: "Card"
            }
          ]}
        />
        <DropdownRow
          {...page}
          marginTop
          label=" Preferred Contact Method"
          keyName={LocationVarKey.ProfileSettingWelcomeBackContactMethod}
          options={[
            {
              label: "Phone Number",
              value: "Phone"
            },
            {
              label: "Email",
              value: "Email"
            }
          ]}
        />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeBackWantShortProfile} label="Short Profile" />
        <Indent {...page}>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.ProfileSettingWelcomeBackWantSecondaryOptional}
            hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeBackWantShortProfile, "1")}
            label="Make Secondary Contact Method Optional"
          />
        </Indent>
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeBackWantConfirmProfile} label="Confirm Profile" />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeBackWantCollectPersona} label="Collect Persona" />
      </Section>
    </>
  );
}
